module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    staticClass: "form-control date-picker",
    attrs: {
      "type": "text",
      "placeholder": "例)平成01年02月03日"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45389940!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/date-picker.pug
// module id = 382
// module chunks = 1